<script lang="ts">
    // import { computed, ref, watch, onUnmounted, watchEffect, onMounted } from 'vue'
    import vm, { JourneyNode } from '@journeys/Journeys.viewmodel';

    // import { NodeType } from '@journeys/Enums'

    // components
    // import NodePresetList from './Partials/NodePresetList.vue'
    // import FluidButton from '@shared/components/FluidButton.vue'
    // import FluidSelect from '@shared/components/FluidSelect.vue'
    // import FluidInput from '@shared/components/FluidInput.vue'
    // import FluidTextarea from '@shared/components/FluidTextarea.vue'
    // import NativeSelect from '@shared/components/NativeSelect.vue'
    // import SelectMany from '@shared/components/SelectMany/SelectMany.vue'
    import MultiSelect from '@shared/components/MultiSelect/MultiSelect.vue';

    // import { vue_ko_sync } from '@shared/KoSync'

    // assets
    // import { ArrowLeftSVG } from '@shared/assets/vector/ui/IconsUI'
    // import { globalMethods } from '@shared/methods'

    const component = {
        name: 'Partial_SegmentNodeSettings',
        disposeWatchers: () => {},
    };
    export default {
        name: component.name,
    };
</script>

<script lang="ts" setup>
    const { /*editor, nav, settings,*/ activeJourney, account } = vm;

    const props = defineProps<{
        data: JourneyNode['data'];
        id: JourneyNode['id'];
    }>();

    const handleSetInitial = (val: any) => {
        if (!props.data.isInitial) {
            props.data.isInitial = true;
            props.data.startingSegment ||= {
                Name: null,
                Type: 'SegmentGroup',
                Bool: 2,
                Segments: [],
            };

            if (activeJourney.startingNode) {
                let node = activeJourney.nodes[activeJourney.startingNode] as JourneyNode;
                delete node.data.isInitial;
                delete node.data.startingSegment;
            }

            activeJourney.startingNode = props.id;
        } else {
            delete props.data.isInitial;
            delete props.data.startingSegment;
            activeJourney.startingNode = null;
        }
    };

    //    const totalContacts = computed(() => {
    //       // let all: any = Object.values(props.data.segments)
    //       // return all.reduce((acc:number, id: string) => acc + account.lists.contactLists[id].ContactCount, 0)
    //       // let a = props.data.startingSegment?.ListId
    //       // if (!a) return 0
    //       // return account.lists.contactLists[a]?.ContactCount || 0
    //       return 0
    //    })

    // const watcher = watch(
    // 	() => [props.data.ListIds, props.data.SegmentIds, props.data.isInitial],
    // 	() => {
    // 		if (!props.data.isInitial) return

    // 		props.data.startingSegment.Segments = []
    // 			.concat(
    // 				props.data.ListIds.map((listId: string) => ({
    // 					Name: null,
    // 					Type: "MemberSegment",
    // 					ListId: listId,
    // 					InList: true,
    // 					Date: null,
    // 					TimeSpanSince: null,
    // 				}))
    // 			)
    // 			.concat(
    // 				props.data.SegmentIds.map((segmentId: string) => ({
    // 					Name: null,
    // 					Type: "SegmentMemberSegment",
    // 					SegmentId: segmentId,
    // 					InSegment: true,
    // 				}))
    // 			)
    // 	},
    // 	{ deep: true }
    // )

    // onUnmounted(() => {
    // 	watcher()
    // })

    // let segmentFilter_ref = ref()
    // const syncData = () => {
    // 	component.disposeWatchers = vue_ko_sync(props.data, segmentFilter_ref.value!, { hasFeature: globalMethods.hasFeature })
    // }

    // onMounted(() => {
    // 	let latest_id = props.id
    // 	let localWatcher = watchEffect(() => {
    // 		if (latest_id === props.id) return

    // 		component.disposeWatchers()

    // 		syncData()
    // 		latest_id = props.id
    // 	})
    // 	syncData()

    // 	onUnmounted(() => {
    // 		localWatcher()
    // 		component.disposeWatchers()
    // 	})
    // })
</script>

<template>
    <div class="section-group mt-sm">
        <h2 class="h3">{{ $Resources.StartingSergmentSettingsHead }}</h2>

        <!-- <div class="mt-l" ref="segmentFilter_ref">
			<segment-filter params="name: title, segment: { SegmentDefinition: startingSegment.Segments  }, namespace: 'startingsegment'"> </segment-filter>

			<segment-filter-dropdown params="namespace: 'startingsegment'">
				<button class="btn btn-default mv-md" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-bind="dropdown: true, fixed: true">
					<span class="glyphicon glyphicon-plus m-xs-r"></span>
					Add <span class="caret m-sm-l"></span>
				</button>
			</segment-filter-dropdown>
		</div> -->

        <label v-if="!activeJourney.startingNode" class="root-checkbox simple-checkbox">
            Set as starting point
            <input type="checkbox" label="testlabel" :checked="props.data.isInitial" @input="handleSetInitial" />
            <div class="pseudo-checkbox"></div>
        </label>

        <!-- <h4 class="subheading mt-md">Contacts: <span>{{ totalContacts }}</span></h4> -->
        <!-- <FluidSelect
         v-model:value="data.segments"
         :items="account.lists.contactLists"
         selectionProp="ListId"
         displayProp="Name"
         placeholder="Choose segment or list"
         /> -->

        <MultiSelect
            class="form-group"
            v-if="account.listings.get('/lists')?.length"
            :items="account.listings.getMap('/lists')"
            :selectedItems="data.ListIds as any[]"
            :label="$Resources.GenericListsLabel"
            displayProp="Name"
            selectProp="ListId"
            selectOnly="ListId"
            @update:selectedItems="(newVal) => (data.ListIds = newVal)"></MultiSelect>

        <!--<template v-else>
         fetching..
      </template>
      <h4 class="subheading">Segments:</h4>
      <template v-if="account.listings.get('/segments')?.length">
         <SelectMany class="segment listing mb-sm" style="margin-left: -5px" mode="edit" :list="account.listings.getMap('/segments')" v-model:selectedItems="data.SegmentIds" selectionProp="SegmentId" displayProp="Name" selectOnly="SegmentId" />
      </template>
      <template v-else>
         fetching..
      </template> -->

        <!-- <div class="input-wrapper align-fl-content-s mt-sm">
         <FluidButton
            class="text-button fl-0"
            :text="`+ New segment`"
            @click="()=>{}"
            />
      </div> -->
    </div>
</template>

<style>
    /*
	.segment.listing {
		left: 5px;
		border-bottom: 1px solid rgb(185, 185, 185);
	}
    */
</style>
